import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import Dropzone from "react-dropzone";
import classNames from "classnames";
import "./DropHandler.css";
export default class DropHandler extends React.Component {
  handleDrop = (files) => {
    if (!files || !files.length) {
      return window.toastr.warning("Unrecognized File Type");
    }
    this.props.importSequenceFromFile(files[0]);
  };
  render() {
    const { children, style, className, disabled } = this.props;
    return /* @__PURE__ */ jsx(
      Dropzone,
      {
        disabled,
        onClick: (evt) => evt.preventDefault(),
        multiple: false,
        accept: [
          ".gb",
          ".gbk",
          ".fasta",
          ".fa",
          ".geneious",
          ".gp",
          ".txt",
          ".dna",
          ".prot",
          ".json",
          ".fastq"
        ],
        onDropRejected: () => {
          window.toastr.error("Error: Incorrect File Type");
        },
        onDrop: this.handleDrop,
        children: ({ getRootProps, isDragActive, isDragReject }) => /* @__PURE__ */ jsxs(
          "div",
          {
            ...getRootProps(),
            ...{
              style,
              className: classNames(className, {
                isActive: isDragActive,
                isRejected: isDragReject
              })
            },
            children: [
              /* @__PURE__ */ jsx(DraggingMessage, {}),
              children
            ]
          }
        )
      }
    );
  }
}
function DraggingMessage() {
  return /* @__PURE__ */ jsx("div", { className: "dropzone-dragging-message", children: "Drop Fasta or Genbank files to view them in the editor. The following extensions are accepted: .gb .gbk .fasta .fa .gp .txt" });
}
